<template>
  <div class="noteList">
    <!--Referece firebase via VUEX-->
    <noteCard v-for="note in noteInfo.noteDatas" :key="note.id" :note="note" />
  </div>
</template>

<script>
import firebase from '@/firebase/firestore';
import { mapGetters, mapActions } from 'vuex'; // mapState,
import noteCard from '@/components/noteCard.vue';

export default {
  components: {
    noteCard,
  },
  data() {
    return {
      userid: firebase.auth().currentUser.uid,
      projectid: this.$route.params.projectId,
      notes: [],
    };
  },
  computed: {
    ...mapGetters(['noteInfo']),
  },
  mounted(){
    // console.log(this.$route.params.projectId)
    this.fetchSpecificProjectNote(this.$route.params.projectId);
    // this.notes = notedb;
  },
  created() {
  },
  methods: {
    ...mapActions(['fetchSpecificProjectNote']),
  },
};
</script>
